"use client";

import { ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
import { usePathname } from "next/navigation";

interface MainNavigationProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isMobile?: boolean;
}

export default function MainNavigation({ 
  isAuthenticated, 
  isAdmin, 
  isMobile = false 
}: MainNavigationProps) {
  const pathname = usePathname();

  const navLinks = [
    { href: "/", label: "Home" },
    { href: "/equipment", label: "Hire Equipment" },
    { href: "/sale", label: "Buy Equipment" },
    { href: "/about", label: "About Us" },
    { href: "/contact", label: "Contact Us" },
    ...(isAdmin
      ? [
          {
            href: "/admin",
            label: "Admin",
            icon: <ShieldCheck size={16} className="mr-1" />,
          },
        ]
      : []),
  ];

  if (isMobile) {
    return (
      <div className="flex flex-col space-y-3 w-full font-body">
        {navLinks.map((link) => (
          <div
            key={link.href}
            onClick={() => window.location.href = link.href}
            className={cn(
              "flex items-center py-4 px-5 rounded-lg transition-all duration-200 hover:bg-gray-50 cursor-pointer",
              pathname === link.href
                ? "text-[var(--color-rr-green)] font-bold border-l-4 border-[var(--color-rr-green)]"
                : "text-black hover:text-[var(--color-rr-green)]",
              "text-xl font-bold w-full"
            )}
          >
            {link.icon}
            {link.label}
          </div>
        ))}
      </div>
    );
  }

  return (
    <nav className="flex items-stretch h-full font-body border border-gray-200">
      {navLinks.map((link, index) => (
        <div
          key={link.href}
          onClick={() => window.location.href = link.href}
          className={cn(
            "text-base font-medium transition-all duration-200 flex items-center justify-center h-full px-6 cursor-pointer",
            index !== navLinks.length - 1 && "border-r border-gray-200",
            pathname === link.href
              ? "text-black font-bold bg-[var(--color-rr-green)]/10"
              : "text-black hover:text-[var(--color-rr-green)] hover:bg-gray-50"
          )}
        >
          {link.icon}
          {link.label}
        </div>
      ))}
    </nav>
  );
}